/**
 * O "?" que abre um micro-tour ali mesmo.
 *
 * ## Por que micro-tour e não um texto de ajuda
 *
 * As três ou quatro perguntas que esta plataforma gera de verdade — *o que
 * significa padrão A?*, *quantas pessoas este grupo libera?*, *qual a
 * diferença entre compartilhado e todo o AI Hub?* — nascem **olhando para o
 * controle**, com a janela aberta e uma decisão pela frente.
 *
 * Um texto de ajuda responderia em outro lugar e em outro momento. O micro-tour
 * responde apontando para o que a pessoa está vendo, e some em um clique.
 *
 * ## Por que estes tours não aparecem no menu
 *
 * Eles levam `contextual: true`, e `disponiveis` os exclui. Um tour que começa
 * dentro de uma janela não tem como se abrir sozinho a partir do menu: a janela
 * não é uma rota, e o motor navega por rota. Oferecê-lo na lista seria uma
 * porta que não leva a lugar nenhum.
 */
import { useTour } from './motor.jsx';

/**
 * @param {string} tour o identificador do micro-tour
 * @param {string} rotulo o que o leitor de tela anuncia; o botão é só um "?"
 */
export function AjudaDoTour({ tour, rotulo }) {
  const { abrir } = useTour();

  return (
    <button
      type="button"
      className="ajuda-tour"
      onClick={() => abrir(tour)}
      aria-label={rotulo}
      title={rotulo}
    >
      ?
    </button>
  );
}

export default AjudaDoTour;
